import { Box, BoxProps, Heading, Text } from "@chakra-ui/react"
import React from "react"
import { Address } from "~/interfaces/entities/Address"
import OrderCompleteAddress from "../../order-complete/OrderCompleteAddress"
import { useTranslation } from "react-i18next"
interface Props extends BoxProps {
  address: Address
  isPickup: boolean
  showHeader?: boolean
}

const OrderSummaryAddress: React.FC<Props> = ({
  address,
  isPickup,
  showHeader = true,
  ...rest
}) => {
  const { name, ...remainingAddress } = address
  const { t } = useTranslation()

  const showDeliveryHeader = !isPickup && showHeader
  const showPickupHeader = isPickup && showHeader

  return (
    <Box {...rest}>
      {showDeliveryHeader && (
        <Heading as="h5" fontSize="md" mb={2} color={"inherit"}>
          {t("components.blocks.OrderCompleteBlock.DeliveryAddress")}
        </Heading>
      )}
      {showPickupHeader && (
        <Heading as="h5" fontSize="md" mb={2} color={"inherit"}>
          {t("components.blocks.OrderCompleteBlock.PickupLocation")}
        </Heading>
      )}
      <Box fontSize="sm">
        <Text mb={2} color={"inherit"}>
          {name}
        </Text>
        <OrderCompleteAddress address={remainingAddress} />
      </Box>
    </Box>
  )
}

export default OrderSummaryAddress
